
import React from 'react';

import css from './SekeletonExplore.module.css';

const SekeletonExplore = ({
  width = '100%',
  height = 100,
  bottom = 14,
  left = 0,
  top = 0,
  right = 0,
  circle = false,
  rounded = 0,
}) => {
  return (
    <div
      className={css.skeleton}
      style={{
        width,
        height,
        marginLeft: left,
        marginRight: right,
        marginBottom: bottom,
        borderRadius: rounded,
        marginTop: top,
        ...(circle && { borderRadius: '100%', height: width }),
      }}
    >
      <div className={css.skeletonStructure}>
        <div className={css.selectField}>
          <div className={css.profileRectangle}></div>
          <div className={css.profileTextOne}></div>
          <div className={css.profileText}></div>
          <div className={css.profileTextTwo}></div>
        </div>
        <div className={css.selectField}>
          <div className={css.profileRectangle}></div>
          <div className={css.profileTextOne}></div>
          <div className={css.profileText}></div>
          <div className={css.profileTextTwo}></div>
        </div>
        <div className={css.selectField}>
          <div className={css.profileRectangle}></div>
          <div className={css.profileTextOne}></div>
          <div className={css.profileText}></div>
          <div className={css.profileTextTwo}></div>
        </div>
        {/* <div className={css.leftSide}>
          <div>
            <div className={css.selectField}></div>
            <div className={css.selectField}></div>
          </div>
          <div>
          <div className={css.selectField}></div>
          <div className={css.selectField}></div>
          </div>
        </div>
        <div className={css.rightSide}>
        <div className={css.selectFieldImage}></div>
        <div className={css.selectField}></div>
        </div> */}
      </div>
    </div>
  );
};

export default SekeletonExplore;